import { post } from '@core/Services/ApiService'
import BetEnquiryResponseDataTransferObject from '../DataTransferObjects/BetEnquiryResponseDataTransferObject'
import type { ILegacyBetModel } from '../Model/ILegacyBetModel'

export function enquireBet(
  betViewModel: ILegacyBetModel
): Promise<BetEnquiryResponseDataTransferObject> {
  return post({ url: '/api/totebet/betcost', body: betViewModel })
}

export function enquireAllUpBet(
  betViewModelDto: ILegacyBetModel
): Promise<BetEnquiryResponseDataTransferObject> {
  return post({ url: '/api/totebet/betcostallup', body: betViewModelDto })
}
